module.exports = __webpack_public_path__ + "static/foodstandslide-13-min-8a2cebbef42403cf03343b101c95f981.jpg";